//
//
//  App
//
//

import "./App.css"
import {Route, Routes} from "react-router-dom";
import RequireLoggedIn from "./components/RequireLoggedIn.tsx";
import AppLayout from "./components/AppLayout.tsx";
import Dashboard from "./routes/Dashboard.tsx";
import Conversations from "./routes/Conversations.tsx";
import {Notifications} from "@mantine/notifications";
import {ModalsProvider} from "@mantine/modals";
import Conversation from "./routes/Conversation.tsx";
import { KeycloakProvider } from "./components/KeycloakProvider";

function App() {
  return (
    <KeycloakProvider>
      <ModalsProvider labels={{ confirm: "Submit", cancel: "Cancel" }}>
        <Routes>
          <Route element={<RequireLoggedIn />}>     
            <Route path="/" Component={AppLayout}>
              <Route index Component={Dashboard} />
              <Route path="conversations" Component={Conversations} />
              <Route path="conversations/:conversationId" Component={Conversation} />              
            </Route>
          </Route>
        </Routes>
        <Notifications />
      </ModalsProvider>
    </KeycloakProvider>
  );
}

export default App
